import { useState } from 'react';
import { BaseModal, ClientCombobox } from '@/components/shared';
import type { ClientSummary } from '@/features/Clients/Data';

interface EditarClienteModalProps {
  isOpen: boolean;
  onClose: () => void;
  clienteIdAtual: string | null;
  onConfirmar: (clienteId: string) => void;
  confirmando?: boolean;
}

/**
 * Corrige o Cliente/Projeto da Solicitação (ex.: erro de digitação na abertura) — já era
 * liberado em firestore.rules ("Corrige erro de digitação" em SolicitacaoUpdate.clienteId),
 * só faltava a UI.
 */
export default function EditarClienteModal({
  isOpen,
  onClose,
  clienteIdAtual,
  onConfirmar,
  confirmando,
}: EditarClienteModalProps) {
  const [cliente, setCliente] = useState<ClientSummary | null>(null);

  const handleClose = () => {
    setCliente(null);
    onClose();
  };

  const handleConfirmar = () => {
    if (!cliente || cliente.id === clienteIdAtual) return;
    onConfirmar(cliente.id);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Alterar Cliente/Projeto"
      maxWidth="max-w-md"
      fullHeight={false}
      actions={
        <div className="flex justify-end gap-3">
          <button type="button" className="btn-secondary" onClick={handleClose}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn-primary"
            disabled={!cliente || cliente.id === clienteIdAtual || confirmando}
            onClick={handleConfirmar}
          >
            {confirmando ? 'Salvando...' : 'Confirmar Troca'}
          </button>
        </div>
      }
    >
      <div className="space-y-3 py-4">
        <p className="rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
          Mudar o Cliente/Projeto pode afetar configurações que dependem dele (Propriedade
          do Equipamento, Máquina Homologada, empresa proprietária no Termo).
        </p>
        <ClientCombobox selectedId={clienteIdAtual} onChange={setCliente} />
      </div>
    </BaseModal>
  );
}
